export enum CountriesEnum {
  PL = "PL",
  UA = "UA",
}
